import { DisplayCity } from '@sales-app/types/DisplayCity'
import { gql } from 'graphql-request'

export namespace PinnedHomesQueries {
  export namespace GET {
    export type Response = { potentialBookingPinnedHomes: PinnedHome[] | null }
  }
  export function getPinnedHomes() {
    return gql`
      query getPinnedHomes($filter: PinnedHomeFilter) {
        potentialBookingPinnedHomes(filter: $filter) {
          id
          homeId
          state
          unitName
          baths
          bedrooms
          squareFootage
          displayCity {
            name
            slug
            id
          }
        }
      }
    `
  }
}

export interface PinnedHome {
  baths: number
  bedrooms: number | null
  displayCity: DisplayCity | null
  homeId: number
  id: number
  squareFootage: number | null
  state: string | null
  unitName: string | null
}
